import { render, staticRenderFns } from "./CorpCompany.vue?vue&type=template&id=16c0c350"
import script from "./CorpCompany.vue?vue&type=script&lang=js"
export * from "./CorpCompany.vue?vue&type=script&lang=js"
import style0 from "./CorpCompany.vue?vue&type=style&index=0&id=16c0c350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports